var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { classNames } from '../../../utils';
import Button from '../Button';
import styles from './FileUploadButton.module.css';
const FileUploadButton = (_a) => {
    var { handleFiles, multiple, nowrap, accept, variant } = _a, buttonProps = __rest(_a, ["handleFiles", "multiple", "nowrap", "accept", "variant"]);
    const hiddenFileInput = useRef(null);
    const onButtonClick = () => {
        if (!hiddenFileInput.current)
            return;
        hiddenFileInput.current.click();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: variant, onClick: onButtonClick }, buttonProps, { className: classNames(buttonProps.className, nowrap ? styles.nowrap : '') }), void 0), _jsx("input", { type: "file", multiple: multiple, ref: hiddenFileInput, accept: accept, onClick: (e) => (e.target.value = ''), onChange: (e) => {
                    var _a;
                    handleFiles(Array.from((_a = e.target.files) !== null && _a !== void 0 ? _a : []));
                }, style: { display: 'none' } }, void 0)] }, void 0));
};
export default FileUploadButton;
